var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import React, { useState } from 'react';

const Tab = ({
  id,
  label,
  children




}) => /*#__PURE__*/
_jsx("div", { className: "hidden", id: id, "data-label": label }, void 0,
children
);







const Tabs = ({ children, onTabSelected }) => {
  const [activeTab, setActiveTab] = useState(children[0].props.id);

  const handleClick = (
  e,
  newActiveTab) =>
  {
    e.preventDefault();
    setActiveTab(newActiveTab);
    onTabSelected(newActiveTab);
  };

  const buttonClass = 'flex-1 text-gray-700 font-medium py-2 w-80 h-14';

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("div", {
      className: "flex border rounded-md shadow-sm md:w-1/2 border-gray-50",
      "data-testid": "tabs-comp" }, void 0,

    children.map((child, index) => /*#__PURE__*/
    _jsx("button", {

      type: "button",
      className: `${buttonClass} ${activeTab === child.props.id ? 'bg-gray-50' : ''} ${
      index !== children.length - 1 ? 'border-r-2 border-gray-50' : ''
      }`,
      onClick: (e) => handleClick(e, child.props.id) }, child.props.id,

    child.props.label
    )
    )
    ), /*#__PURE__*/
    _jsx("div", { className: "py-4" }, void 0,
    children.map((child) => {
      if (child.props.id === activeTab) {
        return /*#__PURE__*/_jsx("div", {}, child.props.id, child.props.children);
      }
      return null;
    })
    )
    ));

};

Tabs.Tab = Tab;



export { Tabs };